// src/utils/api.js
// Centralised fetch wrapper that automatically adds the auth token
// to every admin API request.

const API = process.env.REACT_APP_API_URL

function getToken() {
  try {
    const admin = JSON.parse(localStorage.getItem('rh_admin') || '{}')
    return admin.token || null
  } catch {
    return null
  }
}

function authHeaders(extra = {}) {
  const token = getToken()
  const headers = { 'Content-Type': 'application/json', ...extra }
  if (token) headers['Authorization'] = `Bearer ${token}`
  return headers
}

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: authHeaders(options.headers || {}),
  })
  return res
}

export { API }